<template>
  <div>
    <div class="navless-layout-header">
      <slot name='navbar'>
        <ed-button :to='$routerHistory.previous().path'>
          <i class="fal fa-chevron-left"></i>
          &nbsp;
          Back
        </ed-button>
      </slot>
    </div>
    <div>
      <p style="color:white; margin:0px; height:27px;">t</p>
    </div>
    <div :endpoint="api.$.evedpaycard.cardWithDetails" class="content">
      <div v-if="card">
      <div>
        <p class="page-title">Card Number</p>
      </div>

      <!-- Card Visual -->
      <div class="card-preview-container">
        <div class="card-preview">
          <img src="https://d1a4bxjw35af21.cloudfront.net/images_en/eved-pay-logo.svg" alt="EvedPay Logo">
          <div class="card-number-row">
            <p class="card-number">
              {{ revealed ? formattedCardNumber : '•••• •••• •••• ' + card.cardNumber }}
              <span v-if="revealed" class="copy-icon-card" title="Copy card number" @click="copyCardNumber">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
              </span>
            </p>
          </div>
          <div class="card-details-row">
            <div class="card-field">
              <p class="card-label"><small>VALID THRU</small></p>
              <p class="card-value">{{ formattedExpirationDate }}</p>
            </div>
            <div class="card-field">
              <p class="card-label"><small>CVV</small></p>
              <p class="card-value">{{ revealed ? cardDetails.CVV : '•••' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- State: INITIAL -->
      <div v-if="state === 'INITIAL'" class="otp-section">
        <p class="otp-message">
          {{ otpInstructionMessage }}
        </p>
        <button class="btn-show-card" :disabled="sending" @click="sendOtp">
          {{ sending ? 'Sending...' : 'Show Card Number' }}
        </button>
      </div>

      <!-- State: ENTER_CODE -->
      <div v-if="state === 'ENTER_CODE'" class="otp-section">
        <div class="passcode-section">
          <p class="passcode-label">Passcode</p>
          <p class="passcode-hint">{{ otpPasscodeHint }}</p>
          <p v-if="otpErrorMessage" class="otp-error-message">{{ otpErrorMessage }}</p>
          <div class="otp-boxes">
            <input
              v-for="(digit, index) in 6"
              :key="index"
              :ref="'otpInput' + index"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="1"
              class="otp-box"
              :value="digits[index]"
              :disabled="verifying || codeExhausted"
              @input="onDigitInput(index, $event)"
              @keydown="onDigitKeydown(index, $event)"
              @paste="onPaste($event)"
            />
          </div>
          <p v-if="!hideResend && canResend" class="resend-link" @click="resendOtp">
            Didn't receive it? <a href="#">Resend Code</a>
          </p>
          <p v-else-if="!hideResend" class="resend-cooldown">
            Resend available in {{ resendCountdown }}s
          </p>
        </div>
      </div>


      <!-- Detail Fields -->
      <div class="card-detail-fields">
        <div class="detail-field">
          <div class="detail-label">Account Address</div>
          <div v-if="revealed && cardAddress" class="detail-value">
            {{ cardAddress.Address1 }}<br />
            {{ cardAddress.City }}, {{ cardAddress.State && cardAddress.State.Code }} {{ cardAddress.Zip }}
          </div>
          <div v-else class="detail-value"><span class="skeleton"></span></div>
        </div>
        <div class="detail-field">
          <div class="detail-label">Name on Card</div>
          <div class="detail-value">{{ displayNameOnCard }}</div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import otpCardRevealMixin from './otpCardRevealMixin'

export default {
  alias: 'evedpayshownumber',
  mixins: [otpCardRevealMixin],
  data() {
    return {
      card: null,
      digits: ['', '', '', '', '', '']
    }
  },
  computed: {
    formattedExpirationDate() {
      var exp = this.card ? (this.card.expirationDate || '') : ''
      if (!exp) { return '••/••' }
      var match = exp.match(/\/Date\((\d+)\)\//)
      var d = match ? new Date(parseInt(match[1])) : new Date(exp)
      if (isNaN(d.getTime())) { return exp }
      var mm = ('0' + (d.getMonth() + 1)).slice(-2)
      var yy = String(d.getFullYear()).slice(-2)
      return mm + '/' + yy
    },
    displayNameOnCard() {
      if (!this.card) { return '' }
      var nameOnCard = (this.card.nameOnCard || '').trim()
      return nameOnCard || this.card.holder
    },
    passcode() {
      return this.digits.join('')
    }
  },
  created() {
    this.fetchCard()
  },
  methods: {
    getCardId() {
      return this.card ? this.card.id : null
    },
    getPasscode() {
      return this.digits.join('')
    },
    resetPasscodeInput() {
      this.digits = ['', '', '', '', '', '']
    },
    focusPasscodeInput() {
      this.$nextTick(() => {
        if (this.$refs.otpInput0 && this.$refs.otpInput0[0]) {
          this.$refs.otpInput0[0].focus()
        }
      })
    },
    async fetchCard() {
      const cardId = this.$route.query.cardid
      const r = await this.api.get(this.api.$.evedpaycard.cardWithDetails, { params: { id: cardId } })
      const fullCard = r.data
      if (fullCard) {
        if (this.$user.$.user.UserID !== fullCard.Holder.Id) {
          this.$router.replace(this.$routerHistory.previous().path)
          return
        }
        this.card = {
          id: fullCard.Id,
          accountId: fullCard.AccountId,
          cardNumber: fullCard.CardNumber,
          holder: fullCard.Holder.Name,
          holderUserId: fullCard.Holder.Id,
          nameOnCard: fullCard.NameOnCard || '',
          expirationDate: fullCard.ExpirationDate || ''
        }
      }
    },
    getAccountId() {
      return this.card ? this.card.accountId : null
    },
    onDigitInput(index, event) {
      const value = event.target.value.replace(/[^0-9]/g, '')
      this.$set(this.digits, index, value.slice(0, 1))
      event.target.value = this.digits[index]

      if (value && index < 5) {
        const nextRef = this.$refs['otpInput' + (index + 1)]
        if (nextRef && nextRef[0]) {
          nextRef[0].focus()
        }
      }

      if (this.passcode.length === 6 && !this.verifying) {
        this.verifyOtp()
      }
    },
    onDigitKeydown(index, event) {
      if (event.key === 'Backspace' && !this.digits[index] && index > 0) {
        const prevRef = this.$refs['otpInput' + (index - 1)]
        if (prevRef && prevRef[0]) {
          this.$set(this.digits, index - 1, '')
          prevRef[0].focus()
        }
      }
    },
    onPaste(event) {
      event.preventDefault()
      const pasted = (event.clipboardData || window.clipboardData).getData('text').replace(/[^0-9]/g, '').slice(0, 6)
      for (let i = 0; i < 6; i++) {
        this.$set(this.digits, i, pasted[i] || '')
      }
      if (pasted.length === 6 && !this.verifying) {
        this.verifyOtp()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/_variables.scss";

.content {
  padding: 0 15px;
}

.page-title {
  text-align: left;
  margin-bottom: 10px;
  font-size: 16px;
}

.card-preview-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.card-preview {
  background: linear-gradient(315deg, #8C407B 0%, #63417E 100%);
  border-radius: 7px;
  width: 100%;
  max-width: 360px;
  aspect-ratio: 312 / 180;
  position: relative;

  img {
    height: auto;
    width: 45%;
    position: absolute;
    top: 20px;
    right: 20px;
  }

  p {
    color: #FFFFFF;
    margin: 0;
    text-shadow: 1px 1px 2px #000000;
    letter-spacing: 0.06em;
  }
}

.card-number-row {
  position: absolute;
  bottom: 60px;
  left: 28px;

  .card-number {
    font-size: 19px;
  }
}

.card-details-row {
  display: flex;
  position: absolute;
  left: 28px;
  bottom: 15px;
  gap: 20px;

  .card-field {
    .card-label {
      font-size: 9px;
      opacity: 0.8;
    }
    .card-value {
      font-size: 15px;
    }
  }
}

.copy-icon-card {
  display: inline-block;
  margin-left: 6px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.7);
  vertical-align: middle;
  &:hover { color: #fff; }
}

.btn-show-card {
  background-color: #63417E;
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: normal;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #52346a;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.otp-section {
  margin-bottom: 15px;
}

.otp-message {
  font-size: 13px;
  color: #666;
  text-align: left;
  margin-bottom: 15px;
}

.passcode-section {
  text-align: left;
  margin-bottom: 15px;
}

.passcode-label {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 2px;
}

.passcode-hint {
  color: #333;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 10px;
}

.otp-error-message {
  color: #dc3545;
  font-size: 13px;
  margin-bottom: 8px;
}

.otp-boxes {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.otp-box {
  width: 48px;
  height: 56px;
  text-align: center;
  font-size: 24px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);
  }

  &:disabled {
    background-color: #f5f5f5;
  }
}

.resend-link {
  font-size: 13px;
  margin-top: 10px;
  cursor: pointer;

  a {
    color: #007bff;
  }
}

.resend-cooldown {
  font-size: 13px;
  color: #999;
  margin-top: 10px;
}

.timer-bar {
  margin-bottom: 15px;
}

.timer-text {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  display: block;
}

.timer-track {
  height: 4px;
  background: #e0e0e0;
  border-radius: 2px;
  overflow: hidden;
}

.timer-fill {
  height: 100%;
  background: #63417E;
  border-radius: 2px;
  transition: width 1s linear;
}

.card-detail-fields {
  margin-top: 10px;
  text-align: left;
}

.detail-field {
  padding: 6px 0;

  .detail-label {
    font-size: 13px;
    font-weight: 400;
    color: #888;
    margin-bottom: 1px;
  }

  .detail-value {
    font-size: 13px;
    color: #666;

    .skeleton {
      display: inline-block;
      width: 80px;
      height: 14px;
      background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
      border-radius: 4px;
    }
  }
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/EvedPay/showCardNumber.vue